import { render, staticRenderFns } from "./ResourcesGenerateDocuments.vue?vue&type=template&id=b8cd85d2&"
import script from "./ResourcesGenerateDocuments.vue?vue&type=script&lang=js&"
export * from "./ResourcesGenerateDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports